import { useState } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function BookDemoModal({ open, onClose }: Props) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch('https://readdy.ai/api/form/d79u6m386jhav3jpfrh0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#0F172A]/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-white border border-[#E2E8F0] rounded-2xl w-full max-w-md p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-[#334155]/40 hover:text-[#334155] cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        {submitted ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#ECFDF5] mx-auto mb-4">
              <i className="ri-check-line text-[#22C55E] text-3xl"></i>
            </div>
            <h3 className="text-[#0F172A] font-bold text-xl mb-2 font-poppins">You&apos;re booked!</h3>
            <p className="text-[#334155]/60 text-sm font-inter">We&apos;ll reach out within 24 hours to confirm your strategy call.</p>
            <button
              onClick={onClose}
              className="mt-6 bg-[#F97316] text-white font-semibold px-6 py-2.5 rounded-lg cursor-pointer whitespace-nowrap font-inter"
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <h3 className="text-[#0F172A] font-black text-2xl mb-1 font-poppins">Book Your Demo</h3>
            <p className="text-[#334155]/50 text-sm mb-6 font-inter">Schedule a free strategy call with our team.</p>

            <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-[#334155] text-xs font-semibold block mb-1.5 font-inter">Full Name</label>
                <input
                  name="name"
                  type="text"
                  required
                  placeholder="John Smith"
                  className="w-full bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] text-sm placeholder-[#334155]/30 focus:outline-none focus:border-[#2563EB]/50 transition-colors font-inter"
                />
              </div>
              <div>
                <label className="text-[#334155] text-xs font-semibold block mb-1.5 font-inter">Email Address</label>
                <input
                  name="email"
                  type="email"
                  required
                  placeholder="john@company.com"
                  className="w-full bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] text-sm placeholder-[#334155]/30 focus:outline-none focus:border-[#2563EB]/50 transition-colors font-inter"
                />
              </div>
              <div>
                <label className="text-[#334155] text-xs font-semibold block mb-1.5 font-inter">Business Type</label>
                <select
                  name="business_type"
                  required
                  className="w-full bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] text-sm focus:outline-none focus:border-[#2563EB]/50 transition-colors font-inter cursor-pointer"
                >
                  <option value="">Select your trade</option>
                  <option value="HVAC">HVAC</option>
                  <option value="Plumbing">Plumbing</option>
                  <option value="Roofing">Roofing</option>
                  <option value="Electrical">Electrical</option>
                  <option value="General Contractor">General Contractor</option>
                </select>
              </div>
              <div>
                <label className="text-[#334155] text-xs font-semibold block mb-1.5 font-inter">Phone Number</label>
                <input
                  name="phone"
                  type="tel"
                  placeholder="+1 (555) 000-0000"
                  className="w-full bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] text-sm placeholder-[#334155]/30 focus:outline-none focus:border-[#2563EB]/50 transition-colors font-inter"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#F97316] text-white font-semibold py-3.5 rounded-lg hover:bg-[#ea6c0a] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 font-inter"
              >
                {loading ? 'Submitting...' : 'Schedule Strategy Call'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
